import {
  ApiPaginationParams,
  ApiQueryParams,
  IncludeApiQueryParam,
  ISortingParams,
} from '@/types/api';
import { PaymentPayMethod } from '@/types/payment';
import {
  ApiIndividualPaymentGroup,
  ApiPaginatedPaymentGroups,
  ApiPaymentGroupStats,
} from '@/types/payment-groups';
import qs from 'query-string';
import { ApiService } from './api';

export class PaymentGroupService extends ApiService {
  static PATH = '/payment-groups';

  static async getPaymentGroups(
    filters: ApiQueryParams = {},
    pagination: ApiPaginationParams = {},
    sort?: ISortingParams,
    include?: IncludeApiQueryParam,
  ): Promise<ApiPaginatedPaymentGroups> {
    const queryString = qs.stringify({
      ...filters,
      ...pagination,
      include,
      ...(sort && {
        sort: Object.entries(sort).reduce(
          (acc: string[], [fieldName, sort]) => {
            return [...acc, `${fieldName}[${sort}]`];
          },
          [],
        ),
      }),
    });

    return ApiService.get(`${PaymentGroupService.PATH}?${queryString}`);
  }

  static async retryPaymentGroup(
    paymentGroupId: string,
    paymentMethod?: PaymentPayMethod,
  ): Promise<ApiIndividualPaymentGroup> {
    return ApiService.post(
      `${PaymentGroupService.PATH}/${paymentGroupId}/retry`,
      { ...(paymentMethod && { paymentMethod }) },
    );
  }

  static async getPaymentGroupStats(
    filters?: ApiQueryParams,
  ): Promise<ApiPaymentGroupStats> {
    return ApiService.get(
      `${PaymentGroupService.PATH}/stats?${qs.stringify(filters ?? {})}`,
    );
  }
}
